import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner,SimpleGrid,Center,Box,Button,Text,Input,FormControl,Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,useDisclosure,useToast, Image} from '@chakra-ui/react';




type Props = {
  isOpen:boolean,
  onClose:any,
  btnRef:any,
}

export const RulesModal: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();

  return (
    <>
    <Modal
      onClose={props.onClose}
      finalFocusRef={props.btnRef}
      isOpen={props.isOpen}
      scrollBehavior={'inside'}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>NFT利用規約</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            本利用規約は、SUSHI TOP MARKETING株式会社（以下「当社」といいます）が配布するNFT（以下「本NFT」といいます）の利用条件を定めるものです。<br/><br/>当社から本NFTをお受け取りされた方及び当社以外の第三者から本NFTをご購入された方（以下「本ＮＦＴの保有者」といいます）は、本利用規約に同意したものとみなされ、本NFT及び本コンテンツの利用には本利用規約が適用されるものとします。
            <br/><br/>第１条（ライセンス） 当社は、本NFTの保有者に対して、本NFT及び本コンテンツを全世界において、本利用規約の定めに違反しない範囲で、以下の各号の利用を行うことにつき許諾します。 (1) 個人的に又は家庭内その他これに準ずる限られた範囲内において利用すること (2) ソーシャル・ネットワーク・サービス、ブログその他のインターネット上のメディア関連サービスにおいて本コンテンツを表示すること (3) インターネット上のメタバース関連サービスにおいて、本コンテンツを表示すること (4) 本NFTの販売を目的として、インターネット上のNFT売買プラットフォームその他のNFTの売買に係るサービスを利用し、本NFTを販売すること
            <br/><br/>第２条（複製販売の禁止） 本NFTの保有者は、本コンテンツの複製の販売を行ってはならないものとします。
            <br/><br/>第３条（禁止行為） 本NFTの保有者は、以下の行為を自ら行い、又は第三者に行わせてはならないものとします。 (1) 本コンテンツを、第三者の商品又はサービスの広告、マーケティング目的で使用すること (2) 本コンテンツと結びつけたNFTその他のトークンを作成、発行すること (3) 本コンテンツに関して法令又は公序良俗に違反する行為を行うこと (4) 第三者の権利を侵害し、又は侵害する態様で本コンテンツを使用すること (5) 本コンテンツを、暴力表現、性的表現、差別表現、残虐表現、又は他人の権利を侵害する表現と結びつけて使用すること (7) 本コンテンツに関連して商標権その他の知的財産権を取得し、又はその取得を試みること (8) 本コンテンツに係る著作権、商標権その他の知的財産権を侵害し、又は侵害するおそれのある行為を行うこと
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button onClick={props.onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  </>
  );
};